import { render, staticRenderFns } from "./ApproveReportUser.vue?vue&type=template&id=acf30f76&scoped=true"
import script from "./ApproveReportUser.vue?vue&type=script&lang=js"
export * from "./ApproveReportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf30f76",
  null
  
)

export default component.exports